<template>
	<a 
		:href="path" 
		v-on:click.stop.prevent="updateLanguage" 
		@keyup.enter="updateLanguage" 
		:class="['change-language-link', { 
			iconLangClass: hasIcon,
			'has-icon': hasIcon, 
			'loading': loading
		}]">
			<slot>{{ label }}</slot>
		</a>
</template>

<script>
export default {
	props: ['data', 'classes', 'hasIcon', 'action'],
	data() {
		return {
			nextLang: false,
			label: '',
			loading: false
		}
	},
	computed: {
		path() {
			return '/' + this.nextLang
		},
		iconLangClass() {
			return 'icon-' + this.nextLang
		}
	},
	methods: {
		setInitialLang() {
			this.nextLang = (typeof this.$store.state.lang !== 'undefined') ? ((this.$store.state.lang==='no') ? 'en' : 'no') : ((this.$route.path.startsWith('/no')) ? 'no' : 'en');
			this.label = (this.nextLang==='en') ? this.$t('english') : this.$t('norwegian')
		},
		swapLang() {
			this.setInitialLang()
		},
		updateLoading() {
			if (!this.loading) {
				this.label = this.$t('loading')
			} 
			this.loading = !this.loading
		},
		updateLanguage() {
			this.updateLoading()
			let swapUrl = window.dcSite.apiRoute + 'get/site-config?slug=' + this.$route.params.slug + '&lang=' + this.nextLang
			this.$http.get(swapUrl)
			.then(response => {
				if (response.data.success) {
					this.updateLoading()
					if (this.action === 'update-menu') {
						window.setTimeout(() => {
							this.$emit('languageSwapped', {
								headerMenu: response.data.data.headerMenu,
								sustainabilityMenu: response.data.data.sustainabilityMenu,
								lang: this.nextLang
							})
						}, 500);
					}
					this.$store.dispatch('updateGlobalData', response.data.data)
					if (typeof response.data.data.redirect !== 'undefined' && response.data.data.redirect!==false) {
						/*
						window.location.href = response.data.data.siteUrl.replace('/' + this.nextLang + '/', '') + response.data.data.redirect.path
						return
						*/
						this.$router.push({
							path: response.data.data.redirect.path
						});
					} else {
						//if (this.action !== 'update-menu') {
						this.$router.push({
							name: this.nextLang + '-home'
						});
					}
					this.swapLang();
				}
			})
			.catch(function () {
				this.loading = false
				console.log('Error loading menu')
			});
		}
	},
	created() {
		this.setInitialLang();
	}
}
</script>

<style lang="scss">
  @import "../../styles/scss/global/header/languages";
</style>